export { SpaTreatmentDetailV2Connected as SpaTreatmentDetailV2 } from './container';
